<ng-container *transloco="let convert;">
  @if (detailsState$ | async; as detailsState) {
    <section class="sell-details">
      <div class="container">
        @if (detailsState === 'loading') {
          <app-vdp-loader></app-vdp-loader>
        }
      </div>
      @if (detailsState === 'loaded') {
        <div class="container">
          <div class="sell-details__header">
            <lib-details-header></lib-details-header>
          </div>
        </div>
        <div class="container sell-details__carousel_auctionInfo">
          <div class="row">
            <section class="col-xl-8 sell-details__carousel">
              <app-grid-carousel-toggle [gridcarouselToggle]="gridCarouselData" [images]="images$ | async"
                (isImageGrid)="showImageGrid = $event">
              </app-grid-carousel-toggle>
            </section>
          </div>
          <div class="row">
            <section class="col-xl-8 sell-details__carousel">
              @if (slickAvailable && !showImageGrid) {
                <app-carousel [images]="images$ | async" [carouselTranslate]="carouselData"
                  >
                </app-carousel>
              }
              @if (slickAvailable && showImageGrid) {
                <app-image-grid [images]="images$ | async" [imageGridTranslation]="imageGridTranslations"
                ></app-image-grid>
              }
              @if (!slickAvailable) {
                <div>
                  <h2 class="text-danger">{{convert('sellModule.details.detailsShell.slickSlider')}}</h2>
                  <p>
                    <strong class="text-danger">{{convert('sellModule.details.detailsShell.refreshPage')}}</strong>
                  </p>
                </div>
              }
            </section>
            <section class="sell-details__auction col-xl-4">
              <div>
                <lib-auction-detail></lib-auction-detail>
              </div>
            </section>
          </div>
        </div>
        @if (isDesktop$ | async; as isDesktop) {
          @if (isDesktop.matches) {
            <div class="container">
              <div class="row">
                <div class="col-xl-8">
                  <lib-vehicle-detail></lib-vehicle-detail>
                </div>
                <div class="col-xl-4">
                  <app-book-value></app-book-value>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="row mt-2 pt-4 mb-2">
                <div class="col">
                  <div class="border-top"></div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <lib-equipment-accessories variant="static"></lib-equipment-accessories>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="row my-2 my-4">
                <div class="col">
                  <div class="border-top"></div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-8 mb-4 pb-2">
                  <lib-condition-disclosures></lib-condition-disclosures>
                </div>
                <div class="col-md-4">
                  <lib-seller-update></lib-seller-update>
                  <lib-seller-location class="mt-4"></lib-seller-location>
                  <!-- <lib-vehicle-history class="mt-4"></lib-vehicle-history> -->
                </div>
              </div>
            </div>
          }
          @if (!isDesktop.matches) {
            <accordion [closeOthers]="true">
              <accordion-group panelClass="accordion">
                <button data-track-elem="accordion" data-track-name="Vehicle Details" data-track-trigger="statechange"
                  class="btn btn-link btn-block" accordion-heading type="button">
                  <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i>
                  {{convert('sellModule.details.detailsShell.vehicleDetails')}}
                </button>
                <lib-vehicle-detail [showHeading]="false"></lib-vehicle-detail>
              </accordion-group>
              <accordion-group panelClass="accordion">
                <button data-track-elem="accordion" data-track-name="Book Values" data-track-trigger="statechange"
                  class="btn btn-link btn-block" accordion-heading type="button">
                  <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i>
                  {{convert('sellModule.details.detailsShell.bookValues')}}
                </button>
                <app-book-value [showHeading]="false"></app-book-value>
              </accordion-group>
              <accordion-group panelClass="accordion">
                <button data-track-elem="accordion" data-track-name="Equipment and Accessories"
                  data-track-trigger="statechange" class="btn btn-link btn-block" accordion-heading type="button">
                  <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i>
                  {{convert('sellModule.details.detailsShell.optionsAndAccessories')}}
                </button>
                <div class="detail-carousel-container">
                  <lib-equipment-accessories variant="carousel"></lib-equipment-accessories>
                </div>
              </accordion-group>
              <accordion-group panelClass="accordion">
                <button data-track-elem="accordion" data-track-name="Full Description" data-track-trigger="statechange"
                  class="btn btn-link btn-block" accordion-heading type="button">
                  <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i>
                  {{convert('sellModule.details.detailsShell.fullDescription')}}
                </button>
                <div class="detail-carousel-container">
                  <lib-equipment-accessories variant="long-descriptions-mobile"></lib-equipment-accessories>
                </div>
              </accordion-group>
              <accordion-group panelClass="accordion">
                <button data-track-elem="accordion" data-track-name="Condition and Disclosures"
                  data-track-trigger="statechange" class="btn btn-link btn-block" accordion-heading type="button">
                  <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i>
                  {{convert('sellModule.details.detailsShell.conditionAndDisclosures')}}
                </button>
                <lib-condition-disclosures [showHeading]="false"></lib-condition-disclosures>
              </accordion-group>
              <accordion-group panelClass="accordion">
                <button data-track-elem="accordion" data-track-name="Seller Updates" data-track-trigger="statechange"
                  class="btn btn-link btn-block" accordion-heading type="button">
                  <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i>
                  {{convert('sellModule.details.detailsShell.sellerUpdates')}}
                </button>
                <lib-seller-update [showHeading]="false"></lib-seller-update>
              </accordion-group>
              <accordion-group panelClass="accordion">
                <button data-track-elem="accordion" data-track-name="Seller and Location" data-track-trigger="statechange"
                  class="btn btn-link btn-block" accordion-heading type="button">
                  <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i>
                  {{convert('sellModule.details.detailsShell.sellerAndLocation')}}
                </button>
                <lib-seller-location [showHeading]="false"></lib-seller-location>
              </accordion-group>
              <!-- <accordion-group panelClass="accordion">
              <button class="btn btn-link btn-block" accordion-heading type="button">
                <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i> Vehicle History
              </button>
              <lib-vehicle-history [showHeading]="false"></lib-vehicle-history>
            </accordion-group> -->
          </accordion>
        }
      }
    }
  </section>
}
</ng-container>
